    
    import Dialog from '@mui/material/Dialog';
    import DialogActions from '@mui/material/DialogActions';
    import DialogContent from '@mui/material/DialogContent';
    import DialogContentText from '@mui/material/DialogContentText';
    import DialogTitle from '@mui/material/DialogTitle';
    import React, { useState,useEffect} from 'react';
    import api from '../pages/AxiosFetchData';
    import Helper from '../pages/Helper';
    import {  useNavigate} from 'react-router-dom';
    import { DataGrid, GridToolbar } from '@mui/x-data-grid';

    export default function ProductDialog({productopen,productclose, handleProductDialog}) {
        const [rows, setRows] =  useState([]);
        const Navigate = useNavigate();
        const [filterModel, setFilterModel] = React.useState({
            items: [],
            quickFilterExcludeHiddenColumns: true,
            quickFilterValues: [''],
          });

        useEffect(() => {
            //alert(productopen)
            if(productopen) {
                productclose(true);
                GetData();
            }
          
        }, [productopen]);

        const handleClose = () => {
            productclose(false)
        }

        const GetData = async () => {
            var response; 
            try{
               // alert(apiUrl)
                response =  await api.get(`GetProduct`).refreshToken(Navigate);
                
                if(response)
                {
                    const rowsWithRowNumbers = response.data.map((row, index) => ({
                        ...row,
                        rowNumber: index + 1, 
                        qty : 0
                        }));
                    setRows(rowsWithRowNumbers);
                }
            }catch(e){ 
               console.error(e);
            }
        };

        const handleQtyChange = (value,id) => {
            let newList = Array.from(rows);
            let objToUpdate = newList.find((el) =>  el.product_id == id) // grab first element with matching id
            objToUpdate.qty = value;
            setRows(newList);
          }

        const columns= [
            { field: 'rowNumber', headerName: 'No.', width: 50 },
            // { field: 'id', headerName: 'ID.', width: 250, hideable: false},
            { field: 'product_code', headerName: 'Code.', width: 250 },
            { field: 'product_name', headerName: 'Name', width: 250 },
            { field: 'units_name', headerName: 'Unit', width: 50 },
            { field: 'end_stock', headerName: 'Stock', width: 50 },
             { field: 'last_buy_price', headerName: 'Price', width: 100, valueGetter:({ value }) => value && Helper.formatAsCurrency(value)   },
            {
              field: 'Qty',
              headerName: 'Qty',
              width: 80,
             
              renderCell: (params) => (
                <>
                 <input
                    type="number"
                     className="form-control"
                    value={params.row.qty}
                    onChange={(e) => handleQtyChange(e.target.value, params.row.product_id)}
                  /> 
             </>
                
              ),
          },
          {
            field: 'add',
            headerName: '',
            width: 100,
           
            renderCell: (params) => (
              <>
               <button type='button' className='btn btn-info' onClick={(e) => { handleClose(); handleProductDialog(params.row)}} >ADD</button>
              </>
              
            ),
        },
        ];

        return( 
            <Dialog
                open={productopen}
                onClose={handleClose}
                maxWidth="md"
            >
                <form  role="form"> 
                <DialogTitle>PRODUCT LIST</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        please select an item from the list below.
                    </DialogContentText>
                    <div className='row mb-6'>
                        <div className='col-lg-12'>
                            <DataGrid rows={rows}  columns={columns}  className='fonty'    slotProps={{ toolbar: { showQuickFilter: true } }} 
                                disableColumnSelector
                                disableColumnFilter
                                disableDensitySelector
                                filterModel={filterModel}
                                onFilterModelChange={(newModel) => setFilterModel(newModel)}
                                slots={{ toolbar: GridToolbar }}
                                getRowId={(row) => row.rowNumber} />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn' onClick={handleClose} type='button'>CANCEL</button>
                </DialogActions>
                </form>
                </Dialog>
        )
    }
    
    